var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.353 100.353",
    style: {
      enableBackground: "new 0 0 100.353 100.353"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.957,46.404l17.058,28.549c0.268,0.449,0.751,0.726,1.274,0.73c0.004,0,0.009,0,0.013,0 c0.518,0,1-0.268,1.274-0.708l17.756-28.549c0.044-0.071,0.082-0.145,0.112-0.22c2.123-3.467,3.243-7.427,3.243-11.47 c0-12.15-9.887-22.035-22.04-22.035c-12.149,0-22.034,9.885-22.034,22.035c0,4.044,1.121,8.005,3.245,11.473 C30.886,46.276,30.919,46.341,30.957,46.404z M49.648,15.702c10.499,0,19.04,8.539,19.04,19.035c0,3.565-1.011,7.058-2.923,10.1 c-0.046,0.072-0.084,0.147-0.115,0.225L49.328,71.302L33.662,45.083c-0.034-0.085-0.075-0.168-0.125-0.247 c-1.912-3.042-2.923-6.534-2.923-10.1C30.614,24.241,39.153,15.702,49.648,15.702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.651,42.93c4.517,0,8.192-3.675,8.192-8.192s-3.675-8.192-8.192-8.192s-8.192,3.675-8.192,8.192 S45.134,42.93,49.651,42.93z M49.651,29.546c2.863,0,5.192,2.329,5.192,5.192c0,2.863-2.329,5.192-5.192,5.192 c-2.863,0-5.192-2.329-5.192-5.192C44.458,31.875,46.788,29.546,49.651,29.546z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.595,84.298H30.706c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h37.889 c0.828,0,1.5-0.672,1.5-1.5S69.423,84.298,68.595,84.298z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6d3dd76c105a9e9f6e110016ae2e4774.svg";
export { ForwardRef as ReactComponent };